module.exports = __webpack_public_path__ + "static/media/default-head.12f64dac.svg";